"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationsHttpService = void 0;
const types_1 = require("../../types");
const attach_slot_1 = require("../../types/invitations/attach-slot");
const delete_invitation_1 = require("../../types/invitations/delete-invitation");
const get_invitation_exists_1 = require("../../types/invitations/get-invitation-exists");
const refresh_invitation_1 = require("../../types/invitations/refresh-invitation");
const http_service_1 = require("../http.service");
class InvitationsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/invitations`);
    }
    createInvitation(payload) {
        return this.post('', {
            body: payload,
            schema: types_1.createInvitationApiResponseSchema,
        });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_invitation_1.deleteInvitationApiResponseSchema,
        });
    }
    exists(params) {
        return this.getEntity('exists', {
            params,
            schema: get_invitation_exists_1.getInvitationExistsApiResponseSchema,
        });
    }
    refreshById(id) {
        return this.put(`${id}/refresh`, {
            body: {},
            schema: refresh_invitation_1.refreshInvitationApiResponseSchema,
        });
    }
    attachSlot(id, body) {
        return this.post(`${id}/attach-slot`, {
            body,
            schema: attach_slot_1.attachSlotToInvitationResponseSchema,
        });
    }
}
exports.InvitationsHttpService = InvitationsHttpService;
